import React, { useState, useEffect, useContext } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
// import { findUpper } from "../../../utils/Utils"; // Non utilisé
import { ActionStatus, filterStatus, countryOptions, countryListOptions } from "./UserData";
import moment from "moment";
import swal from "sweetalert";

import {
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  UncontrolledDropdown,
  Modal,
  ModalBody,
  DropdownItem,
  Form,
  Input,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  // Row, // Non utilisé
  Col,
  // UserAvatar, // Non utilisé
  PaginationComponent,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableRow,
  DataTableItem,
  Button,
  RSelect,
  // TooltipComponent, // Non utilisé
} from "../../../components/Component";
// import { Link } from "react-router-dom"; // Non utilisé
import { useForm } from "react-hook-form";
import { UserContext } from "./UserContext";
// import { bulkActionOptions } from "../../../utils/Utils"; // Non utilisé
import http from "../../../utils/http-common";
import ConfirmModal from "../../../components/partials/user-manage/ConfirmModal";

const UserQuots = () => {
  const { contextData } = useContext(UserContext);
  const [data, setData] = contextData;

  // const [sm, updateSm] = useState(false); // Non utilisé
  // const [tablesm, updateTableSm] = useState(false); // Non utilisé
  const [onSearch, setonSearch] = useState(true);
  const [onSearchText, setSearchText] = useState("");
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [showConfirmModal, setShowConfirmModal] = useState({
    isOpen: false,
    quote: null,
    onConfirm: null,
  });
  const [showBulkConfirmModal, setShowBulkConfirmModal] = useState(false);
  const [modal, setModal] = useState({
    edit: false,
    add: false,
    view: false,
  });
  const [editId, setEditedId] = useState();
  const [formData, setFormData] = useState({
    _id: "",
    user: {
      _id: "",
      email: "",
      phone: "",
      country_code: "",
      salutation: "",
      first_name: "",
      middle_name: "",
      last_name: "",
      address: "",
      role: "",
      status: "",
    },
    treatment_info: "",
    source_country: "",
    destination_country: "",
    remarks: "",
    specialty: "",
    status: "",
    createdAt: "",
    date: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);
  // loading, errorVal are only written, never read
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [errorVal, setError] = useState("");
  const [quoteList, setQuoteList] = useState([]);

  useEffect(() => {
    http
      .get("/api/v1/quote")
      .then((response) => {
        setQuoteList(response.data.data);
        setData(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching quotes:", error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (onSearchText !== "") {
      const filteredObject = data.filter((item) => {
        return (
          item._id.toLowerCase().includes(onSearchText.toLowerCase()) ||
          item.source_country.toLowerCase().includes(onSearchText.toLowerCase()) ||
          item.destination_country.toLowerCase().includes(onSearchText.toLowerCase()) ||
          item.status.toLowerCase().includes(onSearchText.toLowerCase())
        );
      });
      setQuoteList([...filteredObject]);
    } else {
      setQuoteList([...data]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // Filter from data (source of truth) to avoid infinite loop - quoteList excluded from deps
  }, [onSearchText, data]);

  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  const resetForm = () => {
    setFormData({
      _id: "",
      user: {
        _id: "",
        email: "",
        phone: "",
        country_code: "",
        salutation: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        address: "",
        role: "",
        status: "",
      },
      treatment_info: "",
      source_country: "",
      destination_country: "",
      remarks: "",
      specialty: "",
      status: "",
      createdAt: "",
      date: "",
    });
  };

  const onFormCancel = () => {
    setModal({ edit: false, add: false, view: false });
    resetForm();
  };

  const onFormSubmit = (submitData) => {
    const submittedData = {
      salutation: formData.salutation,
      first_name: submitData.first_name,
      middle_name: submitData.middle_name,
      last_name: submitData.last_name,
      email: submitData.email,
      phone: submitData.phone,
      country_code: formData.country_code,
      treatment_info: submitData.treatment_info,
      source_country: formData.source_country,
      destination_country: formData.destination_country,
      remarks: submitData.remarks,
      specialty: submitData.specialty,
    };

    http
      .post("/api/v1/quote", submittedData)
      .then((response) => {
        setModal({ add: false });
        fetchQuotes();
        swal("Good job!", "Quote added successfully", "success");
      })
      .catch(function (error) {
        console.error("Error creating quote:", error);
        swal("Opps!", error.response?.data?.error || "An error has occured", "warning");
        setTimeout(() => {
          setError(error.response?.data?.error || error.message);
          setLoading(false);
        }, 2000);
      });
  };

  const onEditSubmit = (submitData) => {
    setLoading(true);
    const submittedData = {
      treatment_info: submitData.treatment_info,
      source_country: formData.source_country,
      destination_country: formData.destination_country,
      specialty: formData.specialty,
      remarks: submitData.remarks || "",
      status: formData.status,
    };
    http
      .put(`/api/v1/quote/${editId}`, submittedData)
      .then((response) => {
        setModal({ edit: false });
        fetchQuotes();
        swal("Good job!", "Quote updated successfully", "success");
      })
      .catch(function (error) {
        console.error("Error updating quote:", error);
        swal("Opps!", error.response?.data?.error || "An error has occured", "warning");
        setTimeout(() => {
          setError(error.response?.data?.error || error.message);
          setLoading(false);
        }, 2000);
      });
  };

  const onEditClick = (id) => {
    quoteList.forEach((item) => {
      if (item._id === id) {
        setFormData({
          _id: item._id,
          user: {
            _id: item.user._id,
            email: item.user.email,
            phone: item.user.phone,
            salutation: item.user.salutation,
            first_name: item.user.first_name,
            middle_name: item.user.middle_name,
            last_name: item.user.last_name,
            address: item.user.address,
            role: item.user.role,
            status: item.user.status,
            country_code: item.user.country_code,
            createdAt: item.user.createdAt,
          },
          treatment_info: item.treatment_info,
          source_country: item.source_country,
          destination_country: item.destination_country,
          remarks: item.remarks,
          specialty: item.specialty,
          status: item.status,
          createdAt: item.createdAt,
        });
        setModal({ edit: true }, { add: false });
        setEditedId(item._id);
      }
    });
  };

  const onViewClick = (id) => {
    quoteList.forEach((item) => {
      if (item._id === id) {
        setFormData({
          _id: item._id,
          user: {
            _id: item.user._id,
            email: item.user.email,
            phone: item.user.phone,
            salutation: item.user.salutation,
            first_name: item.user.first_name,
            middle_name: item.user.middle_name,
            last_name: item.user.last_name,
            address: item.user.address,
            role: item.user.role,
            status: item.user.status,
            country_code: item.user.country_code,
            createdAt: item.user.createdAt,
          },
          treatment_info: item.treatment_info,
          source_country: item.source_country,
          destination_country: item.destination_country,
          specialty: item.specialty,
          remarks: item.remarks,
          status: item.status,
          createdAt: item.createdAt,
          date: item.date,
        });
        setModal({ view: true }, { add: false });
        setEditedId(item._id);
      }
    });
  };

  const confirmDeleteQuote = (item) => {
    const id = item._id || item.id;
    if (!id) return;
    setShowConfirmModal({
      isOpen: true,
      quote: item,
      onConfirm: () => {
        performDeleteQuote(id);
        setShowConfirmModal({ isOpen: false, quote: null, onConfirm: null });
      },
    });
  };

  const performDeleteQuote = (id) => {
    http
      .delete(`/api/v1/quote/${id}`)
      .then(() => {
        swal("Success", "Quote deleted successfully", "success");
        fetchQuotes();
      })
      .catch((error) => {
        console.error("Error deleting quote:", error);
        swal("Error", error.response?.data?.error || "An error occurred", "warning");
      });
  };

  const fetchQuotes = () => {
    http
      .get("/api/v1/quote")
      .then((res) => {
        const list = res.data.data || [];
        setQuoteList(list);
        setData(list);
        setSelectedIds((prev) => {
          const next = new Set(prev);
          list.forEach((item) => next.delete(item._id));
          return next;
        });
      })
      .catch((error) => {
        console.error("Error reloading quotes:", error);
      });
  };

  const toggleSelectAll = () => {
    if (selectedIds.size >= currentItems.length) {
      setSelectedIds(new Set());
    } else {
      setSelectedIds(new Set(currentItems.map((item) => item._id)));
    }
  };

  const toggleSelectOne = (id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const openBulkDeleteConfirm = () => {
    if (selectedIds.size === 0) return;
    setShowBulkConfirmModal(true);
  };

  const performBulkDelete = () => {
    const ids = Array.from(selectedIds);
    setShowBulkConfirmModal(false);
    if (ids.length === 0) return;
    http
      .request({
        method: "delete",
        url: "/api/v1/quote/bulk",
        data: { ids },
      })
      .then(() => {
        swal("Success", `${ids.length} quote(s) deleted successfully`, "success");
        setSelectedIds(new Set());
        fetchQuotes();
      })
      .catch((err) => {
        if (err.response?.status === 404 || err.response?.status === 501) {
          Promise.all(ids.map((id) => http.delete(`/api/v1/quote/${id}`)))
            .then(() => {
              swal("Success", `${ids.length} quote(s) deleted successfully`, "success");
              setSelectedIds(new Set());
              fetchQuotes();
            })
            .catch((e) => {
              console.error("Error deleting quotes:", e);
              swal("Error", e.response?.data?.error || "Some quotes could not be deleted", "warning");
              fetchQuotes();
            });
        } else {
          console.error("Error bulk deleting quotes:", err);
          swal("Error", err.response?.data?.error || "An error occurred", "warning");
        }
      });
  };

  const toggle = () => setonSearch(!onSearch);

  const { errors, register, handleSubmit } = useForm();

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = quoteList.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <React.Fragment>
      <Head title="User List - Compact"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle tag="h3" page>
                Quote Lists
              </BlockTitle>
              <BlockDes className="text-soft">
                <p>You have total {quoteList.length} quotes.</p>
              </BlockDes>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <DataTable className="card-stretch" scrollable>
            <div className="card-inner position-relative card-tools-toggle">
              <div className="card-title-group">
                <div className="card-tools mr-n1">
                  <ul className="btn-toolbar gx-1">
                    <li>
                      <a
                        href="#search"
                        onClick={(ev) => {
                          ev.preventDefault();
                          toggle();
                        }}
                        className="btn btn-icon search-toggle toggle-search"
                      >
                        <Icon name="search"></Icon>
                      </a>
                    </li>
                    <li className="btn-toolbar-sep"></li>
                    {selectedIds.size > 0 && (
                      <>
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={openBulkDeleteConfirm}
                          aria-label="Delete selected quotes"
                        >
                          <Icon name="delete"></Icon>
                          <span>Delete selected ({selectedIds.size})</span>
                        </button>
                        <li className="btn-toolbar-sep"></li>
                      </>
                    )}
                    <button type="button" className="btn btn-primary" onClick={() => setModal({ add: true })}>
                      Add New Quote
                    </button>
                  </ul>
                </div>
              </div>
              <div className={`card-search search-wrap ${!onSearch && "active"}`}>
                <div className="card-body">
                  <div className="search-content">
                    <Button
                      className="search-back btn-icon toggle-search active"
                      onClick={() => {
                        setSearchText("");
                        toggle();
                      }}
                    >
                      <Icon name="arrow-left"></Icon>
                    </Button>
                    <input
                      type="text"
                      className="border-transparent form-focus-none form-control"
                      placeholder="Search by quote id or status"
                      value={onSearchText}
                      onChange={(e) => onFilterChange(e)}
                    />
                    <Button className="search-submit btn-icon">
                      <Icon name="search"></Icon>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <DataTableBody compact>
              <DataTableHead>
                <DataTableRow size="sm" className="nk-tb-col-check">
                  <Input
                    type="checkbox"
                    checked={currentItems.length > 0 && selectedIds.size >= currentItems.length}
                    onChange={toggleSelectAll}
                    aria-label="Select all on page"
                  />
                </DataTableRow>
                <DataTableRow size="lg">
                  <span className="sub-text">User Email</span>
                </DataTableRow>
                <DataTableRow size="lg">
                  <span className="sub-text">Treatment Information</span>
                </DataTableRow>
                <DataTableRow size="lg">
                  <span className="sub-text">Specialty</span>
                </DataTableRow>
                <DataTableRow size="lg">
                  <span className="sub-text">Source Country</span>
                </DataTableRow>
                <DataTableRow size="lg">
                  <span className="sub-text">Destination Country</span>
                </DataTableRow>
                <DataTableRow size="lg">
                  <span className="sub-text">Status</span>
                </DataTableRow>
                <DataTableRow size="lg">
                  <span className="sub-text">Request Date</span>
                </DataTableRow>
                <DataTableRow className="nk-tb-col-tools text-right"></DataTableRow>
              </DataTableHead>
              {currentItems.length > 0
                  ? currentItems.map((item, index) => {
                    const id = item._id || item.id;
                    return (
                      <DataTableItem key={id || `quote-${index}`}>
                        <DataTableRow size="sm" className="nk-tb-col-check" dataLabel="Select">
                          <Input
                            type="checkbox"
                            checked={selectedIds.has(id)}
                            onChange={() => toggleSelectOne(id)}
                            aria-label={`Select quote ${item?.user?.email || id}`}
                          />
                        </DataTableRow>
                        <DataTableRow size="lg" dataLabel="User Email">
                          <span>{item?.user?.email}</span>
                        </DataTableRow>
                        <DataTableRow size="lg" dataLabel="Treatment Information">
                          <span>{item.treatment_info}</span>
                        </DataTableRow>
                        <DataTableRow size="lg" dataLabel="Specialty">
                          <span>{item.specialty}</span>
                        </DataTableRow>
                        <DataTableRow size="lg" dataLabel="Source Country">
                          <span>{item.source_country}</span>
                        </DataTableRow>
                        <DataTableRow size="lg" dataLabel="Destination Country">
                          <span>{item.destination_country}</span>
                        </DataTableRow>
                        <DataTableRow size="lg" dataLabel="Status">
                          <span>{item.status}</span>
                        </DataTableRow>
                        <DataTableRow size="lg" dataLabel="Request Date">
                          <span>{moment(item.createdAt).format("DD/MM/YY")}</span>
                        </DataTableRow>
                        <DataTableRow className="nk-tb-col-tools" dataLabel="Actions">
                          <ul className="nk-tb-actions gx-1">
                            <li>
                              <UncontrolledDropdown>
                                <DropdownToggle tag="a" className="dropdown-toggle btn btn-icon btn-trigger">
                                  <Icon name="more-h"></Icon>
                                </DropdownToggle>
                                <DropdownMenu right>
                                  <ul className="link-list-opt no-bdr">
                                    <li key={`view-${item._id || item.id || index}`} onClick={() => onViewClick(item._id)}>
                                      <DropdownItem
                                        tag="a"
                                        href="#view"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                        }}
                                      >
                                        <Icon name="eye"></Icon>
                                        <span>View</span>
                                      </DropdownItem>
                                    </li>
                                    <li key={`edit-${item._id || item.id || index}`} onClick={() => onEditClick(item._id)}>
                                      <DropdownItem
                                        tag="a"
                                        href="#edit"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                        }}
                                      >
                                        <Icon name="edit-alt-fill"></Icon>
                                        <span>Edit</span>
                                      </DropdownItem>
                                    </li>

                                    <li key={`delete-${item._id || item.id || index}`} onClick={() => confirmDeleteQuote(item)}>
                                      <DropdownItem
                                        tag="a"
                                        href="#delete"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                        }}
                                      >
                                        <Icon name="delete"></Icon>
                                        <span>Delete</span>
                                      </DropdownItem>
                                    </li>
                                  </ul>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </li>
                          </ul>
                        </DataTableRow>
                      </DataTableItem>
                    );
                  })
                : null}
            </DataTableBody>
            <div className="card-inner">
              {currentItems.length > 0 ? (
                <PaginationComponent
                  itemPerPage={itemPerPage}
                  totalItems={quoteList.length}
                  paginate={paginate}
                  currentPage={currentPage}
                />
              ) : (
                <div className="text-center">
                  <span className="text-silent">No data found</span>
                </div>
              )}
            </div>
          </DataTable>
        </Block>

        <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Add Quote</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)}>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Salutation</label>
                      <div className="form-control-wrap">
                        <RSelect
                          name="salutaton"
                          placeholder="Mr. or Mrs."
                          options={filterStatus}
                          onChange={(e) => setFormData({ ...formData, salutation: e.value })}
                        />
                      </div>
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">First Name</label>
                      <input
                        className="form-control"
                        type="text"
                        name="first_name"
                        defaultValue={formData.user.first_name}
                        placeholder="first_name"
                        ref={register({ required: "This field is required" })}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Last Name</label>
                      <input
                        className="form-control"
                        type="text"
                        name="last_name"
                        defaultValue={formData.user.last_name}
                        placeholder="last_name"
                        ref={register({ required: "This field is required" })}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Email </label>
                      <input
                        className="form-control"
                        type="text"
                        name="email"
                        defaultValue={formData.user.email}
                        placeholder="Enter email"
                        ref={register({
                          required: "This field is required",
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "invalid email address",
                          },
                        })}
                      />
                      {errors.email && <span className="invalid">{errors.email.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Country Code</label>
                      <div className="form-control-wrap">
                        <RSelect
                          name="country_code"
                          options={countryOptions}
                          onChange={(e) => setFormData({ ...formData, country_code: e.value })}
                        />
                      </div>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Phone</label>
                      <input
                        className="form-control"
                        type="number"
                        name="phone"
                        defaultValue={formData.user.phone}
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.phone && <span className="invalid">{errors.phone.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Treatment</label>
                      <input
                        className="form-control"
                        type="treatment"
                        name="treatment_info"
                        defaultValue={formData.treatment_info}
                        placeholder="treatment_info"
                        ref={register({ required: "This field is required" })}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Specialty</label>
                      <input
                        className="form-control"
                        type="text"
                        name="specialty"
                        defaultValue={formData.specialty}
                        placeholder="Specialty"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Origin Country</label>
                      <div className="form-control-wrap">
                        <RSelect
                          name="source_country"
                          options={countryListOptions}
                          onChange={(e) => setFormData({ ...formData, source_country: e.value })}
                        />
                      </div>
                    </FormGroup>
                  </Col>

                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Destination Country</label>
                      <div className="form-control-wrap">
                        <RSelect
                          name="destination_country"
                          options={countryListOptions}
                          onChange={(e) => setFormData({ ...formData, destination_country: e.value })}
                        />
                      </div>
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Remarks</label>
                      <input
                        className="form-control"
                        type="text"
                        name="remarks"
                        defaultValue={formData.remarks}
                        placeholder="Remarks"
                      />
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button color="primary" size="md" type="submit">
                          Add Quote
                        </Button>
                      </li>
                      <li>
                        <a
                          href="#cancel"
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </a>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal.edit} toggle={() => setModal({ edit: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Update Quote</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onEditSubmit)}>
                  <input type="hidden" value={formData._id} name="_id" />
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Treatment Info</label>
                      <input
                        className="form-control"
                        type="text"
                        name="treatment_info"
                        defaultValue={formData.treatment_info}
                        placeholder="Treatment Info"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                    <FormGroup>
                      <label className="form-label">Specialty</label>
                      <input
                        className="form-control"
                        type="text"
                        name="specialty"
                        defaultValue={formData.specialty}
                        placeholder="Specialty (derived from treatment)"
                        disabled
                        readOnly
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Origin Country</label>
                      <div className="form-control-wrap">
                        <RSelect
                          name="source_country"
                          options={countryListOptions}
                          defaultValue={{ value: formData.source_country, label: formData.source_country }}
                          onChange={(e) => setFormData({ ...formData, source_country: e.value })}
                        />
                      </div>
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Destination Country</label>
                      <div className="form-control-wrap">
                        <RSelect
                          name="destination_country"
                          options={countryListOptions}
                          defaultValue={{ value: formData.destination_country, label: formData.destination_country }}
                          onChange={(e) => setFormData({ ...formData, destination_country: e.value })}
                        />
                      </div>
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Quotes Created By</label>
                      <input
                        className="form-control"
                        type="text"
                        disabled
                        defaultValue={formData.user.email}
                        placeholder="User email"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        options={ActionStatus}
                        defaultValue={{ value: formData.status, label: formData.status }}
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                      />
                      {errors.password && <span className="invalid">{errors.password.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Remarks</label>
                      <input
                        className="form-control"
                        type="text"
                        name="remarks"
                        defaultValue={formData.remarks}
                        placeholder="Remark (optional)"
                      />
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button color="primary" size="md" type="submit">
                          Update Quote
                        </Button>
                      </li>
                      <li>
                        <a
                          href="#cancel"
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </a>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal.view} toggle={() => setModal({ view: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Quote Details</h5>
              <div className="mt-4">
                <Form className="row gy-4">
                  <input type="hidden" value={formData._id} name="_id" />
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Salutation</label>
                      <p>{formData.user.salutation}</p>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">First Name</label>
                      <p>{formData.user.first_name}</p>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Last Name</label>
                      <p>{formData.user.last_name}</p>
                    </FormGroup>
                  </Col>

                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Email</label>
                      <p>{formData.user.email}</p>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Country Code</label>
                      <p>{formData.user.country_code}</p>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Phone</label>
                      <p>{formData.user.phone}</p>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Treatment Info</label>
                      <p>{formData.treatment_info}</p>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Specialty</label>
                      <p>{formData.specialty}</p>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Souce Country</label>
                      <p>{formData.source_country}</p>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Destination Country</label>
                      <p>{formData.destination_country}</p>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <p>{formData.status}</p>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Created At</label>
                      <p>{moment(formData.createdAt).format("DD/MM/YY")}</p>
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Remarks</label>
                      <p>{formData.remarks}</p>
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <a
                          href="#cancel"
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="btn btn-primary"
                        >
                          Close
                        </a>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <ConfirmModal
          isOpen={showConfirmModal.isOpen}
          onClose={() => setShowConfirmModal({ isOpen: false, quote: null, onConfirm: null })}
          onConfirm={showConfirmModal.onConfirm || (() => {})}
          title="Delete quote?"
          message={
            showConfirmModal.quote
              ? `Are you sure you want to delete this quote (${showConfirmModal.quote.user?.email || showConfirmModal.quote.treatment_info || "N/A"})?\n\nThis action cannot be undone.`
              : "Are you sure you want to delete this quote?"
          }
          confirmText="Delete"
          cancelText="Cancel"
          type="danger"
        />

        <ConfirmModal
          isOpen={showBulkConfirmModal}
          onClose={() => setShowBulkConfirmModal(false)}
          onConfirm={performBulkDelete}
          title="Delete selected quotes?"
          message={`You are about to delete ${selectedIds.size} quote(s). This action cannot be undone.`}
          confirmText="Delete"
          cancelText="Cancel"
          type="danger"
        />
      </Content>
    </React.Fragment>
  );
};
export default UserQuots;
